import { render, staticRenderFns } from "./TablesComponent.vue?vue&type=template&id=54997183&"
import script from "./TablesComponent.vue?vue&type=script&lang=js&"
export * from "./TablesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports